import axios from 'axios';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import Select from 'react-select';
import Swal from 'sweetalert2';
import geografiaFunciones from '../function/geografia.Funciones';
import senaFunciones from '../function/sena.Funciones';


const RegistrarGrupos = ({ actualizarGrupos }) => {

    const { id } = useParams();
    const navigate = useNavigate();

    // Estados para los datos del modelo
    const [fichaGrupo, setFichaGrupo] = useState('');

    // Estados para los programas
    const [programas, setProgramas] = useState([]);
    const [codPrograma, setCodPrograma] = useState('');
    const [programaSeleccionado, setProgramaSeleccionado] = useState('');

    // Estados para los centros
    const [centros, setCentros] = useState([]);
    const [codCentro, setCodCentro] = useState('');
    const [centroSeleccionado, setCentroSeleccionado] = useState('');

    const [finiciolectivaGrupo, setFiniciolectivaGrupo] = useState('');
    const [ffinlectivaGrupo, setFfinlectivaGrupo] = useState('');
    const [finicioproductivaGrupo, setFinicioproductivaGrupo] = useState('');
    const [ffinproductivaGrupo, setFfinproductivaGrupo] = useState('');
    // Ubicación del Grupo
    const [paises, setPaises] = useState([]);
    const [estados, setEstados] = useState([]);
    const [ciudades, setCiudades] = useState([]);

    const [idPais, setIdPais] = useState('');
    const [idEstado, setIdEstado] = useState('');
    const [idCiudad, setIdCiudad] = useState('');

    const [paisSeleccionado, setPaisSeleccionado] = useState('');
    const [estadoSeleccionado, setEstadoSeleccionado] = useState('');
    const [ciudadSeleccionada, setCiudadSeleccionada] = useState('');

    const [estadoGrupo, setEstadoGrupo] = useState('');
    const [observacionGrupo, setObservaciongrupo] = useState('');
    const [cantCuposGrupo, setCantCuposGrupo] = useState('');

    const opcionesPaises = paises.map(p => ({ value: String(p.idPais), label: p.nombrePais }));
    const opcionesEstados = estados.map(e => ({ value: String(e.idEstado), label: e.nombreEstado }));
    const opcionesCiudades = ciudades.map(c => ({ value: String(c.idCiudad), label: c.nombreCiudad }));

    useEffect(() => {
        const getData = async () => {
            try {
                const res = await axios.get(`/api/grupos/listid/${id}`);
                if (!res.data.ok) return;
                const grupo = res.data.grupo;

                // Asignaciones de datos normales
                setFichaGrupo(grupo.fichaGrupo);
                setCodPrograma(grupo.codPrograma);
                setProgramaSeleccionado(grupo.codPrograma);
                setCodCentro(grupo.codCentro);
                setCentroSeleccionado(grupo.codCentro);

                const toDate = d => d ? new Date(d).toISOString().split('T')[0] : '';
                setFiniciolectivaGrupo(toDate(grupo.finiciolectivaGrupo));
                setFfinlectivaGrupo(toDate(grupo.ffinlectivaGrupo));
                setFinicioproductivaGrupo(toDate(grupo.finicioproductivaGrupo));
                setFfinproductivaGrupo(toDate(grupo.ffinproductivaGrupo));

                setEstadoGrupo(grupo.estadoGrupo);
                setObservaciongrupo(grupo.observacionGrupo);
                setCantCuposGrupo(grupo.cantCuposGrupo);

                // Carga de datos geográficos con eliminación de duplicados
                const paisesData = await geografiaFunciones.obtenerPaises();
                const estadosData = grupo.idPais ? await geografiaFunciones.obtenerEstadosPorPais(grupo.idPais) : [];
                const ciudadesData = grupo.idEstado ? await geografiaFunciones.obtenerCiudadesPorEstado(grupo.idEstado) : [];

                const estadosUnicos = Array.from(new Map(estadosData.map(e => [e.idEstado, e])).values());
                const ciudadesUnicas = Array.from(new Map(ciudadesData.map(c => [c.idCiudad, c])).values());

                setPaises(paisesData);
                setEstados(estadosUnicos);
                setCiudades(ciudadesUnicas);

                setIdPais(String(grupo.idPais));
                setIdEstado(String(grupo.idEstado));
                setIdCiudad(String(grupo.idCiudad));

                setPaisSeleccionado(paisesData.find(p => String(p.idPais) === String(grupo.idPais)) ? {
                    value: String(grupo.idPais),
                    label: paisesData.find(p => String(p.idPais) === String(grupo.idPais)).nombrePais
                } : null);

                setEstadoSeleccionado(estadosUnicos.find(e => String(e.idEstado) === String(grupo.idEstado)) ? {
                    value: String(grupo.idEstado),
                    label: estadosUnicos.find(e => String(e.idEstado) === String(grupo.idEstado)).nombreEstado
                } : null);

                setCiudadSeleccionada(ciudadesUnicas.find(c => String(c.idCiudad) === String(grupo.idCiudad)) ? {
                    value: String(grupo.idCiudad),
                    label: ciudadesUnicas.find(c => String(c.idCiudad) === String(grupo.idCiudad)).nombreCiudad
                } : null);

            } catch (err) {
                console.error(err);
                Swal.fire('Error', 'No se pudo cargar el grupo', 'error');
            }
        };

        if (id) getData();
    }, [id]);






    const cleanData = () => {

        setFichaGrupo('');
        setCodPrograma('');
        setProgramaSeleccionado('');
        setCodCentro('');
        setCentroSeleccionado('');
        setFiniciolectivaGrupo('');
        setFfinlectivaGrupo('');
        setFinicioproductivaGrupo('');
        setFfinproductivaGrupo('');
        setIdPais('');
        setIdEstado('');
        setIdCiudad('');
        setPaisSeleccionado('');
        setEstadoSeleccionado('');
        setCiudadSeleccionada('');
        setPaises([]);
        setEstados([]);
        setCiudades([]);
        setEstadoGrupo('');
        setObservaciongrupo('');
        setCantCuposGrupo('');

        setPaisSeleccionado(null);  // Resetea el país
        setEstadoSeleccionado(null); // Resetea el estado
        setCiudadSeleccionada(null); // Resetea la ciudad

        navigate("/institucional/grupos");
    };

    const saveGrupo = async () => {
        try {
            const newGrupo = {
                fichaGrupo,
                codPrograma,
                codCentro,
                finiciolectivaGrupo,
                ffinlectivaGrupo,
                finicioproductivaGrupo,
                ffinproductivaGrupo,
                idPais,
                idEstado,
                idCiudad,
                estadoGrupo,
                observacionGrupo,
                cantCuposGrupo
            };

            const response = await axios.post('/api/grupos/add', newGrupo);
            if (response.data.ok) {
                cleanData();
                Swal.fire({
                    icon: 'success',
                    title: 'El Grupo ha sido registrado con éxito',
                    showConfirmButton: false,
                    timer: 1500
                });
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: response.data.message || 'Hubo un problema al registrar el grupo.'
                });
                actualizarGrupos();
            }

        } catch (error) {
            console.error('Error en saveGrupo:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Hubo un problema con la solicitud.'
            });
        }
    };

    const updateGrupo = async () => {
        try {
            const updatedGrupo = {
                fichaGrupo,
                codPrograma,
                codCentro,
                finiciolectivaGrupo,
                ffinlectivaGrupo,
                finicioproductivaGrupo,
                ffinproductivaGrupo,
                idPais,
                idEstado,
                idCiudad,
                estadoGrupo,
                observacionGrupo,
                cantCuposGrupo
            };

            const response = await axios.put(`/api/grupos/update/${id}`, updatedGrupo);
            if (response.data.ok) {
                Swal.fire({
                    icon: 'success',
                    title: 'El Grupo ha sido actualizado con éxito',
                    showConfirmButton: false,
                    timer: 1500
                });
                actualizarGrupos();
                cleanData();
                navigate('/institucional/grupos'); // Cambia esta ruta según sea necesario
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: response.data.message || 'Hubo un problema al actualizar el grupo.'
                });
            }
        } catch (error) {
            console.error('Error en updateGrupo:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Hubo un problema con la solicitud de actualización.'
            });
        }
    };




    const actions = async (e) => {
        e.preventDefault();
        id ? await updateGrupo() : await saveGrupo();
    };


    // Cargar países al inicio
    useEffect(() => {
        const cargarPaises = async () => {
            try {
                setPaises([]);
                const paisesData = await geografiaFunciones.obtenerPaises();

                const paisesUnicos = paisesData.filter(
                    (pais, index, self) =>
                        index === self.findIndex(p => p.idPais === pais.idPais)
                );

                setPaises(paisesUnicos);
            } catch (error) {
                console.error('Error al cargar países:', error);
            }
        };

        cargarPaises();
    }, []);



    const handlePaisChange = async (selected) => {
        setPaisSeleccionado(selected);
        setIdPais(selected?.value || '');
        setEstadoSeleccionado(null);
        setCiudadSeleccionada(null);
        setEstados([]);
        setCiudades([]);
        if (selected?.value) {
            const data = await geografiaFunciones.obtenerEstadosPorPais(selected.value);
            setEstados(data);
        }
    };

    const handleEstadoChange = async (selected) => {
        setEstadoSeleccionado(selected);
        setIdEstado(selected?.value || '');
        setCiudadSeleccionada(null);
        setCiudades([]);

        if (selected?.value) {
            try {
                const data = await geografiaFunciones.obtenerCiudadesPorEstado(selected.value);
                const ciudadesUnicas = Array.from(new Map(data.map(c => [c.idCiudad, c])).values());
                setCiudades(ciudadesUnicas);
            } catch (error) {
                console.error('Error al cargar ciudades:', error);
            }
        }
    };


    const handleCiudadChange = (selected) => {
        setCiudadSeleccionada(selected);
        setIdCiudad(selected?.value || '');
    };



    // Cargar los programas al montar el componente
    useEffect(() => {
        const cargarProgramas = async () => {
            const programasData = await senaFunciones.obtenerProgramas();
            setProgramas(programasData);
        };

        cargarProgramas();
    }, []);

    // Convertir programas en opciones para react-select
    const opcionesPrograma = programas
        .slice()
        .sort((a, b) => a.nombrePrograma.localeCompare(b.nombrePrograma))
        .map((programa) => ({
            value: programa.codPrograma,
            label: `${programa.codPrograma} - ${programa.nombrePrograma.length > 60
                ? programa.nombrePrograma.substring(0, 60) + '...'
                : programa.nombrePrograma
                }`,
        }));

    const handleProgramaChange = (selectedOption) => {
        const selectedCodPrograma = selectedOption ? selectedOption.value : '';
        setProgramaSeleccionado(selectedCodPrograma);
        setCodPrograma(selectedCodPrograma);
    };


    useEffect(() => {
        const cargarCentros = async () => {
            const centrosData = await senaFunciones.obtenerCentros();
            setCentros(centrosData);
        };

        cargarCentros();
    }, []);

    // Convertir centros en opciones para react-select
    const opcionesCentro = centros
        .slice()
        .sort((a, b) => a.nombreCentro.localeCompare(b.nombreCentro))
        .map((centro) => ({
            value: centro.codCentro,
            label: `${centro.codCentro} - ${centro.nombreCentro.length > 60
                ? centro.nombreCentro.substring(0, 60) + '...'
                : centro.nombreCentro
                }`,
        }));


    const handleCentroChange = (selectedOption) => {
        if (selectedOption) {
            const selectedCodCentro = selectedOption.value;
            setCentroSeleccionado(selectedCodCentro);
            setCodCentro(selectedCodCentro);
        } else {
            // Si se borra la selección
            setCentroSeleccionado(null);
            setCodCentro(null);
        }
    };





    return (
        <div className="container-fluid py-1 px-0 shadow-lg rounded-4 bg-light mt-2 mb-5 ">
            < div className='container-fluid mt-3' >
                <h1>Registrar Grupos</h1>
            </div>


            <div className='mb-5'>
                <form onSubmit={actions}>
                    <div className="container">
                        <div className="row g-3 align-items-end justify-content-center">
                            {/* Campo de Ficha */}
                            <div className="col-md-2">
                                <label htmlFor="ficha" className="form-label">Ficha</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="ficha"
                                    placeholder="Ingrese la ficha"
                                    //required
                                    value={fichaGrupo}  // Vincula el estado con el campo
                                    onChange={(e) => setFichaGrupo(e.target.value)}  // Actualiza el estado al cambiar el valor
                                />
                            </div>

                            {/* Campo de Programa de Formación */}
                            <div className="col-md-6">
                                <label htmlFor="programa" className="form-label">
                                    Programa
                                </label>
                                <Select
                                    id="programa"
                                    options={opcionesPrograma}
                                    onChange={handleProgramaChange}
                                    value={
                                        opcionesPrograma.find((op) => op.value === programaSeleccionado) ||
                                        null
                                    }
                                    placeholder="Seleccione un programa"
                                    isClearable
                                    className="form-control p-0"
                                    classNamePrefix="react-select"
                                />
                            </div>

                            {/* Campo de Centro de Formación */}
                            <div className="col-md-4">
                                <label htmlFor="centro" className="form-label">
                                    Centro de Formación
                                </label>

                                <Select
                                    options={opcionesCentro}
                                    value={opcionesCentro.find(op => op.value === centroSeleccionado) || null}
                                    onChange={handleCentroChange}
                                    placeholder="Seleccione un centro"
                                    isClearable
                                    className="form-control p-0"
                                    classNamePrefix="react-select"
                                />

                            </div>

                            {/* Campo de Fecha Inicio Etapa Lectiva */}
                            <div className="col-md-3">
                                <label htmlFor="fechaInicioLectiva" className="form-label">Fecha Inicio Etapa Lectiva</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    id="fechaInicioLectiva"
                                    //required
                                    value={finiciolectivaGrupo}  // Vincula el estado con el campo
                                    onChange={(e) => setFiniciolectivaGrupo(e.target.value)}  // Actualiza el estado al cambiar el valor
                                />
                            </div>

                            {/* Campo de Fecha Fin Etapa Lectiva */}
                            <div className="col-md-3">
                                <label htmlFor="fechaFinLectiva" className="form-label">Fecha Fin Etapa Lectiva</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    id="fechaFinLectiva"
                                    //required
                                    value={ffinlectivaGrupo}  // Vincula el estado con el campo
                                    onChange={(e) => setFfinlectivaGrupo(e.target.value)}  // Actualiza el estado al cambiar el valor
                                />
                            </div>

                            {/* Campo de Fecha Inicio Productiva */}
                            <div className="col-md-3">
                                <label htmlFor="fechaFinFormacion" className="form-label">Fecha Inicio Productiva</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    id="fechaFinFormacion"
                                    //required
                                    value={finicioproductivaGrupo}  // Vincula el estado con el campo
                                    onChange={(e) => setFinicioproductivaGrupo(e.target.value)}  // Actualiza el estado al cambiar el valor
                                />
                            </div>

                            {/* Campo de Fecha Fin Productiva */}
                            <div className="col-md-3">
                                <label htmlFor="fechaFinFormacion" className="form-label">Fecha Fin Productiva</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    id="fechaFinFormacion"
                                    //required
                                    value={ffinproductivaGrupo}  // Vincula el estado con el campo
                                    onChange={(e) => setFfinproductivaGrupo(e.target.value)}  // Actualiza el estado al cambiar el valor
                                />
                            </div>



                            {/* Campo de Pais */}
                            <div className="col-md-4">
                                <label htmlFor="paisgrupo" className="form-label">País</label>
                                <Select
                                    options={opcionesPaises}
                                    value={paisSeleccionado}
                                    onChange={handlePaisChange}
                                    placeholder="Seleccione un país"
                                    isClearable
                                />
                            </div>

                            <div className="col-md-4">
                                <label htmlFor="estado" className="form-label">Estado/Departamento</label>
                                <Select
                                    options={opcionesEstados}
                                    value={estadoSeleccionado}
                                    onChange={handleEstadoChange}
                                    placeholder="Seleccione un estado"
                                    isClearable
                                    isDisabled={!opcionesEstados.length}
                                />
                            </div>

                            <div className="col-md-4">
                                <label htmlFor="ciudad" className="form-label">Ciudad</label>
                                <Select
                                    options={opcionesCiudades}
                                    value={ciudadSeleccionada}
                                    onChange={handleCiudadChange}
                                    placeholder="Seleccione una ciudad"
                                    isClearable
                                    isDisabled={!opcionesCiudades.length}
                                />
                            </div>

                            <div className="col-md-2">
                                <label htmlFor="cantCuposGrupo" className="form-label">Cupos Solicitados</label>
                                <select
                                    className="form-control"
                                    id="cantCuposGrupo"
                                    required
                                    value={cantCuposGrupo}
                                    onChange={(e) => setCantCuposGrupo(e.target.value)}
                                >
                                    <option value="">Seleccione cupos</option>
                                    {Array.from({ length: 50 }, (_, i) => i + 1).map((numero) => (
                                        <option key={numero} value={numero}>
                                            {numero}
                                        </option>
                                    ))}
                                </select>
                            </div>


                            <div className='col-md-4'>

                                <label htmlFor="estado" className="form-label">Estado</label>
                                <select
                                    className="form-control"
                                    onChange={(e) => setEstadoGrupo(e.target.value)} // Ajusta según el estado que quieras manejar
                                    value={estadoGrupo} // Ajusta según el estado que quieras manejar
                                >
                                    <option value="">Seleccione un estado</option>
                                    <option value="ACTIVO">ACTIVO</option>
                                    <option value="INACTIVO">INACTIVO</option>
                                </select>

                            </div>
                            <div className="col-md-6">
                                <label htmlFor="motivo" className="form-label">
                                    {estadoGrupo === "" || estadoGrupo === undefined
                                        ? "Motivo del estado"
                                        : estadoGrupo === "ACTIVO"
                                            ? "Motivo de apertura"
                                            : "Motivo de cierre"}
                                </label>
                                <select
                                    className="form-control"
                                    onChange={(e) => setObservaciongrupo(e.target.value)}
                                    value={observacionGrupo}
                                    disabled={!estadoGrupo} // Deshabilitar si no hay estado seleccionado
                                >
                                    <option value="">
                                        {estadoGrupo ? "Seleccione un motivo" : "Seleccione un estado primero"}
                                    </option>
                                    {estadoGrupo === "ACTIVO" && (
                                        // Opciones de apertura
                                        <>
                                            <option value="Inicio_programa">Inicio del programa</option>
                                            <option value="Reprogramacion">Reprogramación del grupo</option>
                                            <option value="Apertura_administrativa">Apertura administrativa</option>
                                            <option value="Cambio_modalidad">Cambio de modalidad</option>
                                            <option value="Creacion_nuevo_grupo">Creación de un nuevo grupo</option>
                                            <option value="Demanda_aprendices">Alta demanda de aprendices</option>
                                            <option value="Aumento_cupos">Aumento de cupos</option>
                                            <option value="Fusion_grupos">Fusión de grupos</option>
                                        </>
                                    )}
                                    {estadoGrupo === "INACTIVO" && (
                                        // Opciones de cierre
                                        <>
                                            <option value="Finalizacion_programa">Finalización normal del programa</option>
                                            <option value="Baja_desercion">Baja por alta deserción</option>
                                            <option value="Reprogramacion">Reprogramación del grupo</option>
                                            <option value="Cierre_administrativo">Cierre administrativo</option>
                                            <option value="Fuerza_mayor">Suspensión por fuerza mayor</option>
                                            <option value="Cambio_programa">Cambio de programa</option>
                                            <option value="Fusion_fichas">Fusión de fichas</option>
                                            <option value="Incumplimiento_requisitos">Incumplimiento de requisitos mínimos</option>
                                            <option value="Incumplimiento_instructor">Cierre por incumplimiento del instructor</option>
                                            <option value="Renuncia_instructor">Renuncia del instructor</option>
                                            <option value="Cambio_modalidad">Cambio de modalidad</option>
                                            <option value="Problemas_logisticos">Problemas logísticos</option>
                                            <option value="Reubicacion">Reubicación del grupo</option>
                                            <option value="Problemas_presupuesto">Problemas presupuestarios</option>
                                            <option value="Solicitud_aprendices">Solicitud de cierre por parte de los aprendices</option>
                                            <option value="Cierre_temporal">Cierre temporal</option>
                                            <option value="Terminacion_contrato">Terminación por incumplimiento del contrato</option>
                                            <option value="Evaluacion_baja">Cierre por baja evaluación institucional</option>
                                            <option value="Conflictos_internos">Cierre por conflictos internos</option>
                                        </>
                                    )}
                                </select>

                            </div>
                        </div>

                        {/* Botón de envío */}
                      <div className="col-12 mt-4 mb-5">
                            <div className="row g-3">
                                <div className="col-12 col-md-6">
                                    <button type="submit" className="btn btn-success w-100">{id ? 'Actualizar' : 'Enviar'}</button>
                                </div>
                                <div className="col-12 col-md-6">
                                    <button type="button" className="btn btn-danger w-100"
                                        onClick={cleanData} >
                                        Cancelar
                                    </button>
                                </div>
                            </div>
                        </div>



                    </div>
                </form>
            </div>
        </div>
    );
}

export default RegistrarGrupos;
